import { Drawer } from '@mui/material'
import { COLORS, DSBottomSheet } from '@repo/design-system/index'
import {
  QIcon_check_mark,
  QIcon_chevron_down,
  QIcon_chevron_left,
  QIcon_chevron_right,
  QIcon_close_default,
  QIcon_tune,
} from '@repo/icons/index'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { ACTIVITY_WORDING } from '../../../../helpers/aiTutorActivityHelper'
import {
  useConversationSetting,
  useConversationSettingSetPronunciation,
  useConversationSettingSetSpeed,
} from '../../../../modules/apis/student/conversation'
import { n_ai_tutor, n_event } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { AITutorQuitComfirm } from '../AITutorPopup'

const AITutorActivityListBottomSheet = ({ show, setShow, progress, activityList, setActivity }) => {
  const { t } = useTranslation()

  const onClickActivity = (index) => {
    // 진행되던 오디오 멈추기
    setActivity(index)
    setShow(false)
  }

  //  <DSBottomSheet
  //       enableScroll={true}
  //       closeOnDim={true}
  //       id="AITutorActivityListBottomSheet"
  //       isOpen={show}
  //       setIsOpen={setShow}
  //     >

  return (
    <Drawer
      open={show}
      anchor={'bottom'}
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
      onClose={(_e) => setShow(false)}
    >
      <div
        style={{
          maxHeight: '90%',

          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
          backgroundColor: 'white',
          overflow: 'hidden',
        }}
      >
        <div className="pt-[20px] px-[20px] pb-[20px] flex flex-row gap-2 items-center justify-start self-stretch shrink-0 relative">
          <div className="text-left Title2-18Bd relative flex-1">{t(n_ai_tutor.study_activity.status_title)}</div>
          <QIcon_close_default width={24} height={24} color={COLORS.GRAY500} onClick={() => setShow(false)} />
        </div>
        <div className="w-full flex flex-col justify-center px-[20px] gap-[30px] pb-[64px] mt-[15px]">
          {activityList.map((item, index) => {
            return (
              <div key={index} className="w-full flex flex-row justify-between" onClick={() => onClickActivity(index)}>
                <div className="flex flex-row gap-[8px]">
                  {progress === index && (
                    <div className="px-[6px] py-[2px] bg-gray-100 text-gray-600 Caption-12Bd rounded-[4px] flex items-center justify-center">
                      {t(n_event.card.label_3)}
                    </div>
                  )}
                  <div className="Body1-16Md text-gray-700">
                    {t(ACTIVITY_WORDING[item.type]) || t(n_ai_tutor.study_activity.status_step7) + ` #${index - 4}`}
                  </div>
                </div>
                <QIcon_check_mark width={24} height={24} color={index < progress ? COLORS.PURPLE500 : COLORS.GRAY300} />
              </div>
            )
          })}
        </div>
      </div>
    </Drawer>
  )
}

const AiTutorProgress = ({ progress = 0, activityList, setActivity }) => {
  const [show, setShow] = useState(false)
  const { t } = useTranslation()

  const onClickProgressBar = () => {
    setShow(true)
  }

  return (
    <div className="flex justify-center items-center flex-col w-full overflow-hidden mt-[16px]">
      <div className="flex flex-row gap-[2px] w-full">
        {activityList.map((_, index) => {
          return (
            <div
              key={index}
              className={classNames('h-[8px] rounded-[100px]', index === progress ? 'bg-purple-500' : 'bg-gray-200')}
              style={{ width: `${(1 / activityList.length) * 100}%` }}
            />
          )
        })}
      </div>

      <div
        className="mt-[8px] w-full items-center justify-center flex flex-row gap-[4px] text-gray-500 Caption-12Md"
        onClick={() => onClickProgressBar()}
      >
        <div>{t(ACTIVITY_WORDING[activityList[progress]?.type]) || t(n_ai_tutor.study_activity.status_step7)}</div>
        <QIcon_chevron_down width={12} height={12} color={COLORS.GRAY500} />
      </div>

      <AITutorActivityListBottomSheet
        show={show}
        setShow={setShow}
        progress={progress}
        activityList={activityList}
        setActivity={setActivity}
      />
    </div>
  )
}

const PaperOption = ({ display, selected, onClick }) => (
  <div
    className="pt-[15px] pb-[15px] flex flex-row items-center justify-between self-stretch shrink-0 h-[54px] relative"
    onClick={onClick}
  >
    <div className="text-static-black text-left text-[16px] leading-[160%] font-medium relative">{display}</div>
    {selected && <QIcon_check_mark width={24} height={24} color={COLORS.BLACK} className="shrink-0 relative" />}
  </div>
)

const AITutorSettingSheet = ({ show, setShow, subtitleLang, setSubtitleLang }) => {
  const [page, setPage] = useState<'main' | 'pronunciation' | 'speed' | 'lang'>('main')
  const setting = useConversationSetting()
  const speeds = ['0.8', '1.0', '1.2', '1.5']
  const [selectedSpeed, setSelectedSpeed] = useState(setting.data?.speed)
  const setSpeed = useConversationSettingSetSpeed()

  const pronunciations = ['en-US', 'en-GB', 'en-IN', 'en-AU']
  const [selectedPronunciation, setSelectedPronunciation] = useState(setting.data?.pronunciation)
  const setPronunciation = useConversationSettingSetPronunciation()

  const { t } = useTranslation()

  const getPronunciationName = (pronunciationName) => {
    switch (pronunciationName) {
      case 'en-US':
        return t(n_ai_tutor.study_activity_setting.pro_us)
      case 'en-GB':
        return t(n_ai_tutor.study_activity_setting.pro_uk)
      case 'en-AU':
        return t(n_ai_tutor.study_activity_setting.pro_australia)
      case 'en-IN':
        return t(n_ai_tutor.study_activity_setting.pro_india)
      default:
        return t(n_ai_tutor.study_activity_setting.pro_us)
    }
  }

  useEffect(() => {
    setSelectedSpeed(setting.data?.speed)
  }, [setting.data?.speed])

  useEffect(() => {
    setSelectedPronunciation(setting.data?.pronunciation)
  }, [setting.data?.pronunciation])

  return (
    show && (
      <DSBottomSheet enableScroll={true} closeOnDim={true} id="ai-tutor-setting" isOpen={show} setIsOpen={setShow}>
        <div className="px-[20px] pb-[20px] flex flex-row gap-2 items-center justify-start self-stretch shrink-0 relative">
          <div className="text-left Title2-18Bd relative flex-1">
            {
              {
                main: t(n_ai_tutor.study_activity_setting.title1),
                speed: t(n_ai_tutor.study_activity_setting.category1),
                lang: t(n_ai_tutor.study_activity_setting.category2),
                pronunciation: t(n_ai_tutor.study_activity_setting.category3),
              }[page]
            }
          </div>
          <QIcon_close_default onClick={() => setShow(false)} />
        </div>
        {page === 'main' && (
          <div>
            <div className="bg-white px-[20px] pb-[64px] flex flex-col gap-[32px] items-center justify-start self-stretch shrink-0 relative">
              <div className="flex flex-col gap-0 items-start justify-start self-stretch shrink-0 relative">
                <div
                  className="pt-[15px] pb-[15px] flex flex-row items-center justify-between self-stretch shrink-0 h-[54px] relative"
                  onClick={() => setPage('speed')}
                >
                  <div className="text-static-black text-left Body1-16Md relative">
                    {t(n_ai_tutor.study_activity_setting.category1)}
                  </div>
                  <div className="flex flex-row gap-[2px] items-center justify-start shrink-0 relative">
                    <div className="text-gray-600 text-center Body2-14Bd relative">
                      {setting.data?.speed?.toFixed(1)}
                    </div>
                    <QIcon_chevron_right width={24} height={24} />
                  </div>
                </div>
                <div
                  className="pt-[15px] pb-[15px] flex flex-row items-center justify-between self-stretch shrink-0 h-[54px] relative"
                  onClick={() => setPage('lang')}
                >
                  <div className="text-static-black text-left Body1-16Md relative">
                    {t(n_ai_tutor.study_activity_setting.category2)}
                  </div>
                  <div className="flex flex-row gap-[2px] items-center justify-start shrink-0 relative">
                    <div className="text-gray-600 text-center Body2-14Bd relative">
                      {
                        {
                          ko: t(n_ai_tutor.study_activity_setting.kor),
                          en: t(n_ai_tutor.study_activity_setting.eng),
                          // ja: t(n_ai_tutor.study_activity_setting.ja),
                        }[subtitleLang]
                      }
                    </div>
                    <QIcon_chevron_right width={24} height={24} />
                  </div>
                </div>
                <div
                  className="pt-[15px] pb-[15px] flex flex-row items-center justify-between self-stretch shrink-0 h-[54px] relative"
                  onClick={() => setPage('pronunciation')}
                >
                  <div className="text-static-black text-left Body1-16Md relative">
                    {t(n_ai_tutor.study_activity_setting.category3)}
                  </div>
                  <div className="flex flex-row gap-[2px] items-center justify-start shrink-0 relative">
                    <div className="text-gray-600 text-center Body2-14Bd relative">
                      {getPronunciationName(setting.data?.pronunciation)}
                    </div>
                    <QIcon_chevron_right width={24} height={24} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {page === 'speed' && (
          <div>
            <div className="text-gray-600 text-left text-[14px] leading-[20px] font-medium relative self-stretch px-[20px] pb-[20px]">
              {t(n_ai_tutor.study_activity_setting.detail1)}
            </div>
            <div className="bg-white px-[20px] flex flex-col gap-[20px] items-center justify-start self-stretch shrink-0 relative">
              <div className="flex flex-col gap-[24px] items-start justify-start self-stretch shrink-0 relative">
                <div className="flex flex-col items-start justify-start self-stretch shrink-0 relative">
                  {speeds.map((speed) => (
                    <PaperOption
                      key={speed}
                      display={speed}
                      selected={+speed === +selectedSpeed}
                      onClick={() => {
                        setSelectedSpeed(+speed)
                        setSpeed.mutateAsync(+speed)
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
        {page === 'lang' && (
          <div>
            <div className="text-gray-600 text-left text-[14px] leading-[20px] font-medium relative self-stretch px-[20px] pb-[20px]">
              {t(n_ai_tutor.study_activity_setting.detail2)}
            </div>
            <div className="bg-white px-[20px] flex flex-col gap-[20px] items-center justify-start self-stretch shrink-0 relative">
              <div className="flex flex-col gap-[24px] items-start justify-start self-stretch shrink-0 relative">
                <div className="flex flex-col items-start justify-start self-stretch shrink-0 relative">
                  {['ko', 'en'].map((lang) => (
                    <PaperOption
                      key={lang}
                      display={
                        {
                          ko: t(n_ai_tutor.study_activity_setting.kor),
                          en: t(n_ai_tutor.study_activity_setting.eng),
                        }[lang]
                      }
                      selected={lang === subtitleLang}
                      onClick={() => {
                        setSubtitleLang(lang)
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
        {page === 'pronunciation' && (
          <div>
            <div className="text-gray-600 text-left text-[14px] leading-[20px] font-medium relative self-stretch px-[20px] pb-[20px]">
              {t(n_ai_tutor.study_activity_setting.detail3)}
            </div>
            <div className="bg-white px-[20px] flex flex-col gap-[20px] items-center justify-start self-stretch shrink-0 relative">
              <div className="flex flex-col gap-[24px] items-start justify-start self-stretch shrink-0 relative">
                <div className="flex flex-col items-start justify-start self-stretch shrink-0 relative">
                  {pronunciations.map((pro) => (
                    <PaperOption
                      key={pro}
                      display={getPronunciationName(pro)}
                      selected={pro === selectedPronunciation}
                      onClick={() => {
                        setSelectedPronunciation(pro)
                        setPronunciation.mutateAsync(pro)
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </DSBottomSheet>
    )
  )
}

const AITutorActivityHeader = ({ progress = 0, subtitleLang, setSubtitleLang, activityList, setActivity }) => {
  const [showSetting, setShowSetting] = useState(false)
  const [showQuitConfirm, setShowQuitConfirm] = useState(false)

  return (
    <header className="fixed z-10 flex w-full px-[20px] gap-[16px] h-[52px] items-center">
      <QIcon_chevron_left width={24} height={24} onClick={() => setShowQuitConfirm(true)} />
      <div className="flex-1">
        <AiTutorProgress progress={progress} activityList={activityList} setActivity={setActivity} />
      </div>
      <QIcon_tune width={24} height={24} color={COLORS.BLACK} onClick={() => setShowSetting(true)} />
      {showSetting && (
        <AITutorSettingSheet
          show={showSetting}
          setShow={setShowSetting}
          subtitleLang={subtitleLang}
          setSubtitleLang={setSubtitleLang}
        />
      )}
      <AITutorQuitComfirm show={showQuitConfirm} setShow={setShowQuitConfirm} />
    </header>
  )
}

export default AITutorActivityHeader
